import { FC } from 'react'

import '../../Icons.module.scss'
import { IconProps } from '../../IconProps'

export const TMSeychellesLogo: FC<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width='157'
      height='32'
      viewBox='0 0 157 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6765_192)'>
        <path
          d='M17.4478 20.4648H12.394C11.78 20.4648 11.2133 20.1376 10.9068 19.6064L8.00237 14.5762C7.69587 14.045 7.69587 13.3906 8.00237 12.8584L10.9068 7.82817C11.2133 7.29697 11.7809 6.96977 12.394 6.96977H17.4459L21.459 0.0167542C21.3732 0.010841 21.2885 0 21.2018 0H9.39396C8.14724 0 6.99416 0.665242 6.37031 1.7454L0.467887 11.9714C-0.155962 13.0516 -0.155962 14.382 0.467887 15.4622L6.37129 25.6882C6.99514 26.7684 8.14724 27.4336 9.39494 27.4336H21.2027C21.2905 27.4336 21.3762 27.4228 21.4619 27.4168L17.4488 20.4658L17.4478 20.4648Z'
          fill='#FF0044'
        />
        <path
          d='M30.1288 11.9714L24.2254 1.74538C24.1821 1.6695 24.1298 1.60051 24.0805 1.52856L20.0674 8.4796L22.5953 12.8574C22.9018 13.3886 22.9018 14.043 22.5953 14.5752L20.0694 18.951L24.0825 25.903C24.1308 25.8321 24.183 25.7641 24.2264 25.6882L30.1298 15.4622C30.7537 14.382 30.7537 13.0515 30.1298 11.9714H30.1288Z'
          fill='#28F981'
        />
        <path
          d='M45.3614 22.0767H41.3985V7.87999H36.0559V4.51929H50.7287V7.87999H45.3614V22.0767Z'
          fill='var(--logo-text-color)'
        />
        <path d='M57.3012 22.0767H53.3383V4.51929H57.3012V22.0767Z' fill='var(--logo-text-color)' />
        <path
          d='M69.6156 22.3538C66.9724 22.3538 64.7786 21.4885 63.0302 19.7569C61.2838 18.0272 60.4106 15.8571 60.4106 13.2473C60.4106 10.7056 61.3006 8.56995 63.0805 6.83934C64.8614 5.10774 67.0897 4.24243 69.7664 4.24243C72.3751 4.24243 74.6823 5.22108 76.6889 7.17738L74.3817 10.0118C72.9773 8.47337 71.4556 7.70465 69.8167 7.70465C68.3275 7.70465 67.066 8.21023 66.0292 9.22238C64.9924 10.2336 64.474 11.5581 64.474 13.1971C64.474 13.9008 64.5844 14.5808 64.8062 15.2421C65.0269 15.9014 65.362 16.4957 65.8095 17.022C66.2569 17.5492 66.8157 17.9671 67.4839 18.2776C68.1531 18.586 68.9297 18.7408 69.8167 18.7408C71.3886 18.7408 72.9103 18.0479 74.3817 16.6593L76.7135 19.1921C74.5236 21.2992 72.1573 22.3538 69.6156 22.3538Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M95.8271 22.0767H91.0866L86.02 14.8783L83.5118 17.6625V22.0767H79.5489V4.51929H83.5118V12.6954L90.7851 4.51929H95.4014L88.7785 11.8182L95.8271 22.0767Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M118.2 22.0767H114.638V10.2128L109.646 20.2949H107.088L102.072 10.2128V22.0767H98.5098V4.51929H102.924L108.392 15.3051L113.809 4.51929H118.199L118.2 22.0767Z'
          fill='var(--logo-text-color)'
        />
        <path d='M126.528 22.0767H122.565V4.51929H126.528V22.0767Z' fill='var(--logo-text-color)' />
        <path
          d='M142.378 22.0767H130.892V4.51929H134.855V18.6155H142.378V22.0767Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M156.701 22.0767H145.215V4.51929H149.178V18.6155H156.701V22.0767Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M101.352 31.881C100.41 31.881 99.562 31.5738 98.8116 30.9604L99.3296 29.8998C99.7244 30.2071 100.098 30.4286 100.448 30.5655C100.8 30.7024 101.106 30.7713 101.369 30.7713C101.939 30.7713 102.225 30.5793 102.225 30.1953C102.225 29.9865 102.126 29.824 101.929 29.7059C101.732 29.5877 101.436 29.4823 101.041 29.3888C100.466 29.2135 100.072 29.0629 99.8574 28.9368C99.3916 28.6513 99.1582 28.2269 99.1582 27.6626C99.1582 27.1092 99.3709 26.6848 99.7993 26.3884C100.227 26.093 100.755 25.9443 101.386 25.9443C102.191 25.9443 102.921 26.1551 103.573 26.5775L103.071 27.6547C102.369 27.2599 101.773 27.0629 101.278 27.0629C100.797 27.0629 100.553 27.2244 100.547 27.5484C100.547 27.7345 100.642 27.8901 100.831 28.0151C101.02 28.1402 101.312 28.2505 101.708 28.346L102.069 28.4573C102.149 28.4819 102.295 28.537 102.509 28.6217C102.849 28.7586 103.118 28.9457 103.313 29.183C103.508 29.4203 103.606 29.7354 103.606 30.1303C103.606 30.6896 103.397 31.1209 102.981 31.4251C102.564 31.7294 102.021 31.881 101.352 31.881Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M109.558 31.7904H105.084V26.0349H109.467V27.1122H106.384V28.3617H109.155V29.439H106.384V30.7132H109.558V31.7904Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M113.915 31.7904H112.616V29.9648L110.486 26.0349H111.793L113.264 28.6168L114.703 26.0349H116.01L113.913 29.9323V31.7904H113.915Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M119.639 31.881C118.772 31.881 118.052 31.5974 117.48 31.0303C116.907 30.4631 116.621 29.7521 116.621 28.8964C116.621 28.0634 116.913 27.3633 117.497 26.7961C118.081 26.2289 118.811 25.9453 119.688 25.9453C120.544 25.9453 121.3 26.2663 121.958 26.9074L121.202 27.8359C120.741 27.3318 120.241 27.0797 119.705 27.0797C119.217 27.0797 118.804 27.2451 118.463 27.5769C118.123 27.9088 117.954 28.343 117.954 28.8797C117.954 29.1101 117.99 29.3336 118.063 29.5503C118.135 29.7669 118.245 29.9619 118.392 30.1342C118.538 30.3065 118.721 30.4444 118.94 30.5458C119.159 30.6472 119.414 30.6984 119.705 30.6984C120.22 30.6984 120.719 30.471 121.202 30.016L121.966 30.8471C121.248 31.5374 120.473 31.883 119.64 31.883L119.639 31.881Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M128.51 31.7904H127.211V29.5217H124.605V31.7904H123.306V26.0349H124.605V28.4356H127.211V26.0349H128.51V31.7904Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M134.817 31.7904H130.343V26.0349H134.726V27.1122H131.643V28.3617H134.414V29.439H131.643V30.7132H134.817V31.7904Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M140.17 31.7904H136.403V26.0349H137.702V30.6551H140.17V31.7904Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M145.275 31.7904H141.509V26.0349H142.808V30.6551H145.275V31.7904Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M151.088 31.7904H146.614V26.0349H150.997V27.1122H147.914V28.3617H150.685V29.439H147.914V30.7132H151.088V31.7904Z'
          fill='var(--logo-text-color)'
        />
        <path
          d='M154.746 31.881C153.804 31.881 152.956 31.5738 152.206 30.9604L152.724 29.8998C153.118 30.2071 153.492 30.4286 153.842 30.5655C154.194 30.7024 154.5 30.7713 154.763 30.7713C155.333 30.7713 155.619 30.5793 155.619 30.1953C155.619 29.9865 155.52 29.824 155.323 29.7059C155.126 29.5877 154.83 29.4823 154.435 29.3888C153.86 29.2135 153.466 29.0629 153.251 28.9368C152.786 28.6513 152.552 28.2269 152.552 27.6626C152.552 27.1092 152.765 26.6848 153.193 26.3884C153.621 26.093 154.149 25.9443 154.78 25.9443C155.585 25.9443 156.315 26.1551 156.967 26.5775L156.465 27.6547C155.763 27.2599 155.167 27.0629 154.672 27.0629C154.191 27.0629 153.946 27.2244 153.941 27.5484C153.941 27.7345 154.036 27.8901 154.225 28.0151C154.414 28.1402 154.706 28.2505 155.102 28.346L155.463 28.4573C155.543 28.4819 155.689 28.537 155.903 28.6217C156.243 28.7586 156.512 28.9457 156.707 29.183C156.902 29.4203 157 29.7354 157 30.1303C157 30.6896 156.791 31.1209 156.375 31.4251C155.958 31.7294 155.415 31.881 154.746 31.881Z'
          fill='var(--logo-text-color)'
        />
      </g>
      <defs>
        <clipPath id='clip0_6765_192'>
          <rect width='157' height='32' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
